exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\r\n  margin-bottom: 0px;\r\n}\r\n\r\nhr {\r\n  border-top: 2px solid #e4e4e4;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/receipt/receipt.component.css
// module id = ../../../../../src/app/component/receipt/receipt.component.css
// module chunks = main